var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "event-details-box" }, [
    _c(
      "div",
      { staticClass: "event-registration-box" },
      [
        _c("payment-summary", {
          attrs: {
            formTitle: _vm.eventConfig["names-label-your-total"],
            priceTitle: "",
            products: _vm.products,
            donationPrice: _vm.donation,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "event-form-wrap event-box-shadow" },
      [
        _vm.initForm
          ? _c(
              "el-form",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.processing,
                    expression: "processing",
                  },
                ],
                ref: "dynamicForm",
                attrs: {
                  "label-position": "top",
                  "label-width": "100px",
                  model: _vm.dynamicForm,
                  "element-loading-text": "Validate transaction...",
                },
              },
              [
                _vm._l(_vm.tickets, function (item) {
                  return _c(
                    "div",
                    { key: item.code, staticClass: "mb-4" },
                    _vm._l(
                      _vm.dynamicForm[item.code],
                      function (participant, index) {
                        return _c(
                          "div",
                          {
                            key: item.code + index,
                            staticClass: "event-rg-form",
                          },
                          [
                            index === 0
                              ? _c(
                                  "h6",
                                  [
                                    item.type === "individual"
                                      ? [
                                          _vm._v(
                                            _vm._s(_vm.groupTitle(item.code))
                                          ),
                                        ]
                                      : [
                                          _vm._v(
                                            _vm._s(_vm.ticketName(item.code))
                                          ),
                                        ],
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center event-step-active",
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "event-step-count" },
                                  [_vm._v(_vm._s(index + 1))]
                                ),
                                _vm._v(" "),
                                item.type === "individual"
                                  ? _c(
                                      "span",
                                      { staticClass: "event-step-text" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.ticketName(item.code))
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      { staticClass: "event-step-text" },
                                      [_vm._v("Table Owner")]
                                    ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-row" },
                              [
                                item.type === "table"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-12 mt-2 mb-3 event-table-captain-text",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.eventConfig[
                                              "validation-contact-form"
                                            ]["event-table-captain"]
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.donationDetail &&
                                !_vm.eventConfig["registration-locked"]
                                  ? _c(
                                      "div",
                                      { staticClass: "col-md-12 mt-2" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass: "event-checkbox-style",
                                          },
                                          [
                                            _c("input", {
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                checked:
                                                  participant.isDonationDetailUsed,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.handleDonationDetailChecked(
                                                    item.code,
                                                    index
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass:
                                                "event-cstm-checkbox",
                                            }),
                                            _vm._v(
                                              "\n                Use " +
                                                _vm._s(
                                                  _vm.donationDetail.first_name
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm.donationDetail.last_name
                                                ) +
                                                " details\n              "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-2 mt-2" },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "Prefix",
                                          prop:
                                            item.code + "." + index + ".prefix",
                                          rules: _vm.fieldRule("prefix"),
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              placeholder: "Prefix",
                                              disabled:
                                                participant.isNullprefix &&
                                                (participant.isDonationDetailUsed ||
                                                  _vm.eventConfig[
                                                    "registration-locked"
                                                  ]),
                                            },
                                            model: {
                                              value: participant.prefix,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  participant,
                                                  "prefix",
                                                  $$v
                                                )
                                              },
                                              expression: "participant.prefix",
                                            },
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "Select",
                                                value: "",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.eventConfig["prefix-list"]
                                                .items,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.prefix,
                                                  attrs: {
                                                    value: item.prefix,
                                                    label: item.prefix,
                                                  },
                                                })
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-10 mt-2" }, [
                                  _c("div", { staticClass: "form-row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "First name",
                                              prop:
                                                item.code +
                                                "." +
                                                index +
                                                ".firstName",
                                              rules: _vm.fieldRule("firstName"),
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "First name",
                                                disabled:
                                                  participant.isNullfirstName &&
                                                  (participant.isDonationDetailUsed ||
                                                    _vm.eventConfig[
                                                      "registration-locked"
                                                    ]),
                                              },
                                              on: {
                                                blur: function ($event) {
                                                  return _vm.onParticipantChange(
                                                    item.code,
                                                    index
                                                  )
                                                },
                                              },
                                              model: {
                                                value: participant.firstName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    participant,
                                                    "firstName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "participant.firstName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "Last name",
                                              prop:
                                                item.code +
                                                "." +
                                                index +
                                                ".lastName",
                                              rules: _vm.fieldRule("lastName"),
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "Last name",
                                                disabled:
                                                  participant.isNulllastName &&
                                                  (participant.isDonationDetailUsed ||
                                                    _vm.eventConfig[
                                                      "registration-locked"
                                                    ]),
                                              },
                                              model: {
                                                value: participant.lastName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    participant,
                                                    "lastName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "participant.lastName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "Post Nominals",
                                              prop:
                                                item.code +
                                                "." +
                                                index +
                                                ".postNominals",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "eg: AO, BM",
                                              },
                                              model: {
                                                value: participant.postNominals,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    participant,
                                                    "postNominals",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "participant.postNominals",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-6 mt-4" },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "Informal Name",
                                          prop:
                                            item.code +
                                            "." +
                                            index +
                                            ".informalName",
                                          rules: _vm.fieldRule("informalName"),
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "eg: Meggie",
                                            disabled:
                                              participant.isNullinformalName &&
                                              (participant.isDonationDetailUsed ||
                                                _vm.eventConfig[
                                                  "registration-locked"
                                                ]),
                                          },
                                          model: {
                                            value: participant.informalName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                participant,
                                                "informalName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "participant.informalName",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-6 mt-4" },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "Company Title",
                                          prop:
                                            item.code +
                                            "." +
                                            index +
                                            ".companyTitle",
                                          rules: _vm.fieldRule("companyTitle"),
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder:
                                              "eg: Human Resource Manager",
                                          },
                                          model: {
                                            value: participant.companyTitle,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                participant,
                                                "companyTitle",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "participant.companyTitle",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-12 mt-4" },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "Company Name",
                                          prop:
                                            item.code +
                                            "." +
                                            index +
                                            ".companyName",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "Company name",
                                          },
                                          model: {
                                            value: participant.companyName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                participant,
                                                "companyName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "participant.companyName",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-6 mt-4" },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "Email address",
                                          prop:
                                            item.code + "." + index + ".email",
                                          rules: _vm.fieldRule("email"),
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            type: "email",
                                            placeholder:
                                              "eg: name@email.com.au",
                                            "prefix-icon": "el-icon-message",
                                            disabled:
                                              participant.isNullemail &&
                                              (participant.isDonationDetailUsed ||
                                                _vm.eventConfig[
                                                  "registration-locked"
                                                ]),
                                          },
                                          model: {
                                            value: participant.email,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                participant,
                                                "email",
                                                $$v
                                              )
                                            },
                                            expression: "participant.email",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-6 mt-4" },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "Mobile number",
                                          prop:
                                            item.code + "." + index + ".mobile",
                                          rules: _vm.fieldRule("mobile"),
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "eg: 0412 345 678",
                                            "prefix-icon": "el-icon-phone",
                                            disabled:
                                              participant.isNullmobile &&
                                              (participant.isDonationDetailUsed ||
                                                _vm.eventConfig[
                                                  "registration-locked"
                                                ]),
                                          },
                                          model: {
                                            value: participant.mobile,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                participant,
                                                "mobile",
                                                $$v
                                              )
                                            },
                                            expression: "participant.mobile",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.eventDetail["RegistrationQuestion"] !== null
                                  ? _c(
                                      "div",
                                      { staticClass: "col-md-12 mt-4" },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label:
                                                _vm.eventDetail[
                                                  "RegistrationQuestion"
                                                ],
                                              prop:
                                                item.code +
                                                "." +
                                                index +
                                                ".registrationComment",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder:
                                                  _vm.eventDetail[
                                                    "RegistrationQuestion"
                                                  ],
                                              },
                                              model: {
                                                value:
                                                  participant.registrationComment,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    participant,
                                                    "registrationComment",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "participant.registrationComment",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.type === "individual"
                                  ? [
                                      _vm.eventDetail.CollectDiet
                                        ? [
                                            _c(
                                              "div",
                                              { staticClass: "col-md-6 mt-4" },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      label:
                                                        "Dietary requirements",
                                                      prop:
                                                        item.code +
                                                        "." +
                                                        index +
                                                        ".dietaryRequirements",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticClass: "w-100",
                                                        attrs: {
                                                          placeholder:
                                                            "Dietary requirements",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.onParticipantChange(
                                                              item.code,
                                                              index
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            participant.dietaryRequirements,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              participant,
                                                              "dietaryRequirements",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "participant.dietaryRequirements",
                                                        },
                                                      },
                                                      [
                                                        _c("el-option", {
                                                          attrs: {
                                                            label: "Select",
                                                            value: "",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          _vm.eventConfig[
                                                            "diet-options"
                                                          ].items,
                                                          function (item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item[
                                                                  "diet-option"
                                                                ],
                                                                attrs: {
                                                                  value:
                                                                    item[
                                                                      "diet-option"
                                                                    ],
                                                                  label:
                                                                    item[
                                                                      "diet-option"
                                                                    ],
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            participant.dietaryRequirements.toLowerCase() ===
                                            "other"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-md-6 mt-4",
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label:
                                                            "Dietary Other",
                                                          prop:
                                                            item.code +
                                                            "." +
                                                            index +
                                                            ".dietaryOther",
                                                          rules:
                                                            _vm.fieldRule(
                                                              "dietaryOther"
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          attrs: {
                                                            placeholder:
                                                              "eg: Dietary Other",
                                                          },
                                                          model: {
                                                            value:
                                                              participant.dietaryOther,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                participant,
                                                                "dietaryOther",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "participant.dietaryOther",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.eventDetail.CollectAccessibility
                                        ? _c(
                                            "div",
                                            { staticClass: "col-md-6 mt-4" },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label:
                                                      "Accessibility requirements",
                                                    prop:
                                                      item.code +
                                                      "." +
                                                      index +
                                                      ".accessibilityRequirements",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      staticClass: "w-100",
                                                      attrs: {
                                                        placeholder:
                                                          "Accessibility requirements",
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.onParticipantChange(
                                                            item.code,
                                                            index
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          participant.accessibilityRequirements,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            participant,
                                                            "accessibilityRequirements",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "participant.accessibilityRequirements",
                                                      },
                                                    },
                                                    [
                                                      _c("el-option", {
                                                        attrs: {
                                                          label: "Select",
                                                          value: "",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        _vm.eventConfig[
                                                          "access-options"
                                                        ].items,
                                                        function (item) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: item[
                                                                "access-option"
                                                              ],
                                                              attrs: {
                                                                value:
                                                                  item[
                                                                    "access-option"
                                                                  ],
                                                                label:
                                                                  item[
                                                                    "access-option"
                                                                  ],
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            index < _vm.dynamicForm[item.code].length - 1
                              ? _c("hr", { staticClass: "my-4" })
                              : _vm._e(),
                          ]
                        )
                      }
                    ),
                    0
                  )
                }),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _vm.eventDetail && _vm.eventDetail["DonationFunction"] !== null
                  ? _c(
                      "div",
                      { staticClass: "col-md-12 mt-2 event-rg-form" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "useDonation" } },
                          [
                            _c(
                              "el-checkbox",
                              {
                                model: {
                                  value: _vm.dynamicForm.useDonation,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dynamicForm,
                                      "useDonation",
                                      $$v
                                    )
                                  },
                                  expression: "dynamicForm.useDonation",
                                },
                              },
                              [
                                _c("span", {
                                  staticClass: "event-cstm-checkbox",
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.eventConfig["names-label-donation"]
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.dynamicForm.useDonation
                          ? [
                              _c("p", [_vm._v("Select amount")]),
                              _vm._v(" "),
                              _c(
                                "el-radio-group",
                                {
                                  attrs: { size: "medium" },
                                  on: { change: _vm.onSelectAmount },
                                  model: {
                                    value: _vm.dynamicForm.donation,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.dynamicForm, "donation", $$v)
                                    },
                                    expression: "dynamicForm.donation",
                                  },
                                },
                                _vm._l(_vm.getAmountLists, function (gift, i) {
                                  return _c(
                                    "el-radio",
                                    {
                                      key: i,
                                      attrs: {
                                        label:
                                          typeof gift === "object"
                                            ? gift["gift-amount"]
                                            : gift,
                                        border: "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            typeof gift === "object"
                                              ? "$" + gift["gift-amount"]
                                              : "$" + gift
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                              _vm._v(" "),
                              _c("p", [_vm._v("Enter your own amount")]),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { staticClass: "custom-input" },
                                [
                                  _c("img", {
                                    staticClass: "dollar-sign",
                                    attrs: {
                                      src: require("../../assets/icons/dollar.svg"),
                                      alt: "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    attrs: { placeholder: "Enter amount" },
                                    on: { input: _vm.validateCustomAmount },
                                    model: {
                                      value: _vm.dynamicForm.customDonation,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.dynamicForm,
                                          "customDonation",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "dynamicForm.customDonation",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("el-alert", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.amountError.show,
                                    expression: "amountError.show",
                                  },
                                ],
                                attrs: {
                                  title: _vm.amountError.message,
                                  type: "error",
                                  "show-icon": "",
                                },
                                on: {
                                  close: function ($event) {
                                    _vm.amountError = false
                                  },
                                },
                              }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        !_vm.valid
          ? _c(
              "div",
              { staticClass: "mb-3 px-4" },
              [
                _vm.eventConfig && _vm.eventConfig["validation-event-tickets"]
                  ? _c("el-alert", {
                      attrs: {
                        title:
                          _vm.eventConfig["validation-event-tickets"][
                            "validation-event-general"
                          ],
                        type: "error",
                        "show-icon": "",
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isOneClickRequired
          ? _c(
              "div",
              { staticClass: "mb-3 px-4" },
              [
                _vm.eventConfig && _vm.eventConfig["oneclick-required"]
                  ? _c("el-alert", {
                      attrs: {
                        title:
                          "This event is invite only and you must include yourself as part of registration.",
                        type: "error",
                        "show-icon": "",
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.freeEvent.show
          ? _c(
              "div",
              { staticClass: "mb-3 px-4" },
              [
                _c("el-alert", {
                  attrs: {
                    title: _vm.freeEvent.message,
                    type: "error",
                    "show-icon": "",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isDuplicateParticipant
          ? _c(
              "div",
              { staticClass: "mb-3 px-4" },
              [
                _c("el-alert", {
                  attrs: {
                    title: "You cannot register the same person more than once",
                    type: "error",
                    "show-icon": "",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "event-btn d-flex flex-wrap event-rg-form" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-secondary",
              on: { click: _vm.onBackClick },
            },
            [_vm._v("Back")]
          ),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "btn btn-primary", on: { click: _vm.onNextClick } },
            [
              _vm._v("Next "),
              _c("i", { staticClass: "far fa-arrow-right ml-2" }),
            ]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }